import { createContext } from "react";

const LocalesContext = createContext({ });

export default LocalesContext;
